import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';
import { Logo, NamedLink } from '../../../../components';

import css from './SectionHomeFooter.module.css';

const SectionHomeFooter = () => {
  return (
    <footer className={css.foot}>
      <NamedLink className={css.logoLink} name="LandingPage">
        <Logo
          layout="mobile"
          className={css.logoWrap}
          logoImageClassName={css.logoImage}
          alt="setcircle"
        />
      </NamedLink>
      <p className={css.tag}>
        <FormattedMessage id="LandingPage.mobileHome.footer.tagline" />
      </p>
      <div className={css.cols}>
        <NamedLink name="SearchPage">
          <FormattedMessage id="LandingPage.mobileHome.footer.findProps" />
        </NamedLink>
        <NamedLink name="NewListingPage">
          <FormattedMessage id="LandingPage.mobileHome.footer.listYourProps" />
        </NamedLink>
        <a href="https://setcircle.info/" target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="LandingPage.mobileHome.footer.howItWorks" />
        </a>
        <a
          href="https://www.setcirclehelp.com/en/articles/14308263-overall-renting-guide"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="LandingPage.mobileHome.footer.overallRentingGuide" />
        </a>
        <NamedLink name="CMSPage" params={{ pageId: 'our-mission' }}>
          <FormattedMessage id="LandingPage.mobileHome.footer.ourMission" />
        </NamedLink>
        <NamedLink name="CMSPage" params={{ pageId: 'contact-us' }}>
          <FormattedMessage id="LandingPage.mobileHome.footer.contactUs" />
        </NamedLink>
      </div>
      <div className={css.legal}>
        <span>
          <FormattedMessage id="LandingPage.mobileHome.footer.copyright" />
        </span>
        <NamedLink name="TermsOfServicePage">
          <FormattedMessage id="LandingPage.mobileHome.footer.termsOfService" />
        </NamedLink>
        <NamedLink name="PrivacyPolicyPage">
          <FormattedMessage id="LandingPage.mobileHome.footer.privacyPolicy" />
        </NamedLink>
      </div>
    </footer>
  );
};

export default SectionHomeFooter;
